export const firebaseConfig = {
    apiKey: 'AIzaSyCbHjsj1X1tNEsGJwlA05v7ETdTOxTypOE',
    authDomain: 'sunny-bananas.firebaseapp.com',
    projectId: 'sunny-bananas',
    storageBucket: 'sunny-bananas.appspot.com',
    messagingSenderId: '376354945824',
    appId: '1:376354945824:web:7e90361d918138ff48f545',
    measurementId: 'G-XF467G1H30'
}
